import React from 'react'
import {
	EuiButtonIcon,
	EuiDescriptionList,
	EuiDescriptionListDescription,
	EuiDescriptionListTitle,
	EuiToolTip,
} from '@equipmentshare/ds2'
import { FileCopyLineIcon } from '@equipmentshare/ds2-icons'
import { FlexCenterContainer, TruncatedLink } from '../RequestDetails.styles'
import { SMALL_GAP } from '../RequestDetails.constants'
import { formatPhoneNumber } from '../../../utils/formatters/phone'

type User = {
	firstName?: string | null,
	lastName?: string | null,
	emailAddress?: string | null,
}

type ContactInfoProps = {
	user: User | null | undefined,
	phone?: string | null,
	onCopy: ( text: string, label: string ) => void,
}

/**
 * Component for displaying contact information (email and phone) with copy-to-clipboard functionality
 */
export default function ContactInfo( { user, phone, onCopy }: ContactInfoProps ) {
	return (
		<EuiDescriptionList compressed>
			<EuiDescriptionListTitle>Requested by</EuiDescriptionListTitle>
			<EuiDescriptionListDescription>
				{user
					? `${user.firstName} ${user.lastName}`
					: 'Unknown'
				}
			</EuiDescriptionListDescription>
			{user?.emailAddress && (
				<>
					<EuiDescriptionListTitle>Email</EuiDescriptionListTitle>
					<EuiDescriptionListDescription>
						<FlexCenterContainer gap={SMALL_GAP}>
							<TruncatedLink href={`mailto:${user.emailAddress}`}>
								{user.emailAddress}
							</TruncatedLink>
							<EuiToolTip content="Copy email">
								<EuiButtonIcon
									iconType={FileCopyLineIcon}
									onClick={() => onCopy( user.emailAddress ?? '', 'Email' )}
									aria-label="Copy email address"
									size="xs"
									display="empty"
								/>
							</EuiToolTip>
						</FlexCenterContainer>
					</EuiDescriptionListDescription>
				</>
			)}
			<EuiDescriptionListTitle>Phone</EuiDescriptionListTitle>
			<EuiDescriptionListDescription>
				{phone ? (
					<FlexCenterContainer gap={SMALL_GAP}>
						<a href={`tel:${phone}`}>
							{formatPhoneNumber( phone )}
						</a>
						<EuiToolTip content="Copy phone">
							<EuiButtonIcon
								iconType={FileCopyLineIcon}
								onClick={() => onCopy( phone ?? '', 'Phone number' )}
								aria-label="Copy phone number"
								size="xs"
								display="empty"
							/>
						</EuiToolTip>
					</FlexCenterContainer>
				) : (
					<div>—</div>
				)}
			</EuiDescriptionListDescription>
		</EuiDescriptionList>
	)
}
